import { useEffect, useRef } from "react";
import api from "@/lib/api";

// One global event that every live view listens on so the whole app stays fresh in near-real-time.
export const SYNC_EVENT = "gridforge:synced";

// Kick a Gmail sync, then — once the background pull has had a moment to land — tell every
// mounted view to reload. Errors are swallowed (offline / Gmail not connected is a no-op).
export async function triggerEmailSync(delayMs = 4000) {
  try {
    await api.post("/email/sync");
  } catch {
    /* not connected / offline — ignore */
  }
  window.setTimeout(() => window.dispatchEvent(new Event(SYNC_EVENT)), delayMs);
}

// Re-run `fn` whenever a sync completes. Uses a ref so it always calls the latest
// closure without re-subscribing on every render.
export function useSyncedRefresh(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const h = () => ref.current && ref.current();
    window.addEventListener(SYNC_EVENT, h);
    return () => window.removeEventListener(SYNC_EVENT, h);
  }, []);
}
